import { Line } from 'src/components/atoms/Line';
import { Loader } from 'src/components/atoms/Loader';
import { Pagination } from 'src/components/molecules/Pagination';
import { ShowState } from 'src/components/molecules/ShowState';
import { ListView } from 'src/components/templates';
import useOwner from 'src/features/owner/hooks/useOwner';
import useOwnerList from 'src/features/owner/hooks/useOwnerList';
import OwnerListFilters from './components/OwnerListFilters';
import OwnerRow from './components/OwnerRow';
import { PaginationPadding } from './styles';

const OwnerListPage = () => {
  const { allowCreateOwners } = useOwner();
  const {
    owners,
    isLoading,
    error,
    onUpdateStatus,
    isUpdatingStatus,
    onGetAll,
    count,
    page,
    rowsPerPage,
    onSearch,
    searchQuery
  } = useOwnerList();

  if (isLoading) {
    return <Loader />;
  }

  const OwnersPageContent = () => {
    return (
      <>
        {owners?.map((owner) => (
          <div key={owner.name}>
            <Line height="tiny" />
            <OwnerRow
              owner={owner}
              onUpdateStatus={onUpdateStatus}
              isUpdatingStatus={isUpdatingStatus}
            />
          </div>
        ))}

        <Line height="tiny" />

        {error && (
          <ShowState
            variant="error"
            type="information"
            buttonLabel="Please try again"
            message="Something went wrong"
            onClick={() => onGetAll(page, rowsPerPage)}
          />
        )}

        <PaginationPadding>
          <Pagination
            name="OwnerPagination"
            pageInit={page}
            rowsPerPageInit={rowsPerPage}
            rowsPerPage={[5, 10, 20, 50, 100, 250, 500]}
            totalRows={count}
            onNext={(page, rowsPerPage) => onGetAll(page, rowsPerPage)}
            onPrev={(page, rowsPerPage) => onGetAll(page, rowsPerPage)}
            onRowsPerPage={(page, rowsPerPage) => onGetAll(page, rowsPerPage)}
          />
        </PaginationPadding>
      </>
    );
  };

  const EmptySearchResults = () => {
    if (searchQuery) {
      return (
        <ShowState
          message="Try adjusting your search or filter to find<br/> what you are looking for"
          searchText={decodeURIComponent(searchQuery)}
          variant="search"
          type="searchEmpty"
        />
      );
    }
    return <ShowState message="There are no owners yet" type="user" variant="empty" />;
  };

  return (
    <ListView
      title="Owners"
      filters={
        <OwnerListFilters
          allowCreateOwners={allowCreateOwners}
          onSearch={onSearch}
          searchQuery={searchQuery}
        />
      }
    >
      {owners?.length > 0 ? <OwnersPageContent /> : <EmptySearchResults />}
    </ListView>
  );
};

export default OwnerListPage;
